module.exports = __webpack_public_path__ + "images/cov-03-faq-desktop.png";